<template>
	<div :class="`base-modal layout-${layoutType}
        ${!showDesktop || forceMobile ? 'mobile' : ''} ${extraClasses}`">
        <div :class="`base-modal-con ${alignCenter ? 'center': ''} ${!hasCloseButton ? 'has-no-close-btn': ''}`">
            <div class="content">
                <a v-if="hasCloseButton" @click="closeModal" class="base-modal-close">
                    <i class="icon icon-close"></i>
                </a>
                <div class="base-modal-content">
                    <slot></slot>
                </div>
            </div>
        </div>
        <div class="backdrop" @click="closeBackDrop"></div>
	</div>
</template>

<script>
    import BaseModal from '@views/common/BaseModal/base_modal'

    export default {
    	mixins: [BaseModal]
    }
</script>

<style lang="scss" src="./base_modal.scss"></style>
